import { Component, OnInit, Output, ViewChild,EventEmitter, ChangeDetectorRef, SimpleChanges, AfterViewInit } from '@angular/core';
import { CompanyManagementViewService } from '../services/company-management-view.service';
import { EmpresaComponent } from './empresa/empresa.component';
import { AtributosComponent } from 'app/modules/company-view/company-view-detail/atributos/atributos.component'
import { SharedService } from 'app/modules/common/services/shared-service';
import { CompanySideBarTreeViewService } from '../services/company-side-bar-tree-view.service';
import {Subscription} from 'rxjs'
import { MatTabChangeEvent } from '@angular/material/tabs';
import { EmpresaService } from '../services/empresa.service';
import { Empresa } from './models/Empresa/Empresa';
import Utils from 'app/Utils';

@Component({
    selector: 'app-company-view-detail',
    templateUrl: './company-view-detail.component.html',
    styleUrls: ['./company-view-detail.component.scss'],
    standalone: false
})
export class CompanyViewDetailComponent implements OnInit {

  @ViewChild(AtributosComponent) childAtributos: AtributosComponent;
  @ViewChild(EmpresaComponent) appEmpresa: EmpresaComponent;

  public ShowTabPanels = false
  permissionList: Array<string>;
  editAttributoPremission: boolean;
  editPremit: boolean = false;
  editProcess: boolean = false;

  editBtnShow = false;
  cancelBtnShow = false;
  guardarBtnShow = false;

  selectedTab=0;
  message: string;
  permit38: number;
  clickEventSubscriptionFromTreeNode:Subscription;

  companyName:string='';
  sendDataToTree:any;
  protocolo:string;
  isProtolo:boolean=false;
  private empresa: Empresa;
  public selectedCompanyId;

  @ViewChild('tabGroup') tabGroup;

  @Output() sendDataToTreeViewNode =new EventEmitter();

  constructor(
    private _sharedService: SharedService,
    public _companyManagementViewService: CompanyManagementViewService,
    private _companySideBarTreeViewService: CompanySideBarTreeViewService,
    private _changeDetection: ChangeDetectorRef,
    private _empresaService: EmpresaService
  ) { 
  }
  

  ngOnInit(): void {
       this.permissionList = Utils.decrypt(localStorage.getItem('permissionIds')).split(',');
       this._companyManagementViewService.clickedNewCompany$.subscribe((node)=>{
    
        this.companyName = node.name
        this.selectedCompanyId = node.id
        this.initFirstTab();
        this.editPremit = false;      

        this.selectedTab = 0

        if(this.permissionList.includes('20')) {
          this.selectedTab=0;
        }else if(this.permissionList.includes('24')){
          this.selectedTab=1;
        }else if(this.permissionList.includes('43')){
          this.selectedTab=2;
        }else if(this.permissionList.includes('9')){
          this.selectedTab=3;
        }else if(this.permissionList.includes('45')){
          this.selectedTab=4;
        }else if(this.permissionList.includes('6')){
          this.selectedTab=5;
        }else if(this.permissionList.includes('50')){
          this.selectedTab=6;
        }else if(this.permissionList.includes('15')){
          this.selectedTab=7;
        }

        this.ShowTabPanels = false
        this._changeDetection.detectChanges();
        this.ShowTabPanels = true
        this._changeDetection.detectChanges();          
      
      })
    
  }


  onSelectTabs(event:MatTabChangeEvent) {
    if(event.tab.textLabel=="Empresa") {
      this.selectedTab=0;
    }else if(event.tab.textLabel=="Atributos"){
      this.selectedTab=1;
    }else if(event.tab.textLabel=="Personal de contacto"){
      this.selectedTab=2;
    }else if(event.tab.textLabel=="Registro"){
      this.selectedTab=3;
    }else if(event.tab.textLabel=="Convenios"){
      this.selectedTab=4;
    }else if(event.tab.textLabel=="Absentismo"){
      this.selectedTab=5;
    }else if(event.tab.textLabel=="Documentación"){
      this.selectedTab=6;
    }else if(event.tab.textLabel=="Protocolo"){
      this.selectedTab=7;
    }
    
    this.permit38 = this.permissionList.indexOf('38');
    //this.selectedTab = event.index
    if (this.selectedTab === 0) {
      this.editBtnShow = true;
      this.cancelBtnShow = false;
      this.guardarBtnShow = false;    
    }

    if (this.selectedTab === 1 && this.permit38 != -1) {
      this.editBtnShow = true;
      this.cancelBtnShow = false;
      this.guardarBtnShow = false;
      this.editPremit = false;
    }

    if (this.selectedTab === 2) {
      this.editBtnShow = false;
      this.cancelBtnShow = false;
      this.guardarBtnShow = false;
    }

    if (this.selectedTab === 3) {
      this.editBtnShow = false;
      this.cancelBtnShow = false;
      this.guardarBtnShow = false;
    }

    if (this.selectedTab === 4) {
      this.editBtnShow = false;
      this.cancelBtnShow = false;
      this.guardarBtnShow = false;
    }

    if (this.selectedTab === 5) {
      this.editBtnShow = false;
      this.cancelBtnShow = false;
      this.guardarBtnShow = false;
    }

    if (this.selectedTab === 6) {
      this.editBtnShow = false;
      this.cancelBtnShow = false;
      this.guardarBtnShow = false;
    }

    if(this.selectedTab===7){
      this.editBtnShow = true;
      this.cancelBtnShow = false;
      this.guardarBtnShow = false;   
      this.loadCompanyDetails();
    }else
    {
      this.isProtolo=false;
    }
  }

  private loadCompanyDetails()
  {
    this._empresaService.GetEmpresaById(this.selectedCompanyId)
    .subscribe(res => {
      if (res.result) {
        this.protocolo=res.result.observaciones;
      }
    });
  }

  private saveCompanyProtocolo()
  {
    const empresa = new Empresa();
    empresa.EmpresaId=this.selectedCompanyId;
    empresa.Observaciones=this.protocolo;
    this._empresaService.UpdateEmpresaProtocolo(empresa)
    .subscribe(res => {
      if(res.code==0)
      {
        this.isProtolo=false;
        this._sharedService.ShowSnackBar('Actualizado con éxito', 'Okay', 2000);
      } else {
        this._sharedService.ShowSnackBar('Error al guardar', 'Okay', 2000);
      }
    }, err => {
      this._sharedService.ShowSnackBar('Error al guardar', 'Okay', 2000);
    })
  }

  private initFirstTab() {
    if (this.selectedTab === 0 && this.permit38 != -1) {
      this.editBtnShow = true;
      this.cancelBtnShow = false;
      this.guardarBtnShow = false;
    }
    if (this.selectedTab === 1 && this.permit38 != -1) {
      this.editBtnShow = true;
      this.cancelBtnShow = false;
      this.guardarBtnShow = false;
    }
  }

  public onEdit() {
    
    this.cancelBtnShow = true;
    this.guardarBtnShow = true;
    this.editBtnShow = false;
    this.editPremit = false;

    if (this.selectedTab === 0) {
      this.appEmpresa.EnableFormFields(true);
    }
     
    if (this.selectedTab === 1) {
      this.childAtributos.editPremit = true
    }

    if (this.selectedTab === 7) {
      // Protocolo tab
      this.isProtolo=true;
      //Protocolo end
    }
  }

  public onSave()
  {   
    this.cancelBtnShow = false;
    this.guardarBtnShow = false;
    this.editBtnShow = true;

    if (this.selectedTab === 0) 
    {
      this.appEmpresa.Submit();
      //if form dosent have errors disable fields
      let isFormValid = this.appEmpresa.GetFormValidity()
      if (!isFormValid) {     
        this.cancelBtnShow = true;
        this.guardarBtnShow = true;
        this.editBtnShow = false;
      }
    }
    
    if (this.selectedTab === 1) {
      //disable attribute tab 
     this.childAtributos.editPremit = false     
     this.childAtributos.updateAttributos()
     //get all data need for attribute tab
     this.childAtributos.initializeAttributeTab()
    }

    if(this.selectedTab===7) {
      this.saveCompanyProtocolo();
    }
  }

  public onCancel() {
    this.cancelBtnShow = false;
    this.guardarBtnShow = false;
    this.editBtnShow = true;
    if (this.selectedTab === 0) {
      this.appEmpresa.GetEmpresaById(this.appEmpresa.selectedCompanyId);
      this.appEmpresa.EnableFormFields(false);
    }
    if (this.selectedTab === 1) {
      this.childAtributos.editPremit = false
      //get all data need for attribute tab
      this.childAtributos.initializeAttributeTab()
    }
    if (this.selectedTab === 7) {
      // Protocolo tab
      this.isProtolo=false;
      this.loadCompanyDetails();
      //Protocolo end
    }
  }
  sendData(event){
    this.sendDataToTreeViewNode.emit(event);
    this.sendDataToTree=event;
  }

}

